import raf from 'raf';
export default function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      raf(shouldUpdate);
    }
  };

  raf(shouldUpdate);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-smooth/es6/setRafTimeout.js
// module id = null
// module chunks = 